
      <select  #input  [(ngModel)]="value" style="width: 100%;">
        <option *ngFor="let item of options" value="{{item.CityId}}">{{item.NameCity}}</option>
       </select>